<template>
    <div class="row bottom-widgets">
        <div class="col-md-6 d-flex">
            <vuestic-widget class="no-h-padding no-v-padding">
                <!-- <vuestic-feed :initialPosts="posts"></vuestic-feed> -->
                <div class="p-3">
                    <h2 class="text-center mt-2"><strong>Aulas Teóricas</strong></h2>
                    <div class="row d-flex">
                        <div class="col-6 d-flex justify-content-center">
                            <div class="card col-12">
                                <div class="card-body">
                                    <h5 class="card-title">Teóricas Finalizadas</h5>
                                    <h2 class="card-text mt-4">
                                        <i class="fa fa-check icon-size text-success"></i>
                                        <span>
                                            {{ teoricasFinalizadas }}
                                        </span>
                                    </h2>
                                </div>
                            </div>
                        </div>
                        <div class="col-6 d-flex justify-content-center">
                            <div class="card col-12">
                                <div class="card-body">
                                    <h5 class="card-title">Teóricas Canceladas</h5>
                                    <h2 class="card-text mt-4">
                                        <i class="fa fa-ban stats-icon text-danger"></i>
                                        <span>
                                            {{ teoricasCanceladas }}
                                        </span>
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row d-flex">
                        <div class="col-6 d-flex justify-content-center">
                            <div class="card col-12">
                                <div class="card-body">
                                    <h5 class="card-title">Teóricas Pendentes</h5>
                                    <h2 class="card-text mt-4">
                                        <i class="fa fa-hourglass-half icon-size"></i>
                                        <span>
                                            {{ teoricasPendentes }}
                                        </span>
                                    </h2>
                                </div>
                            </div>
                        </div>
                        <div class="col-6 d-flex justify-content-center">
                            <div class="card col-12">
                                <div class="card-body">
                                    <h5 class="card-title">Teóricas Realizadas</h5>
                                    <h2 class="card-text mt-4">
                                        <i class="fa fa-calendar-check-o icon-size text-success"></i>
                                        <span>
                                            {{ teoricasRealizadas }}
                                        </span>
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </vuestic-widget>
        </div>
        <div class="col-md-6 d-flex">
            <vuestic-widget class="business-posts">
                <!-- <vuestic-social-news class="vuestic-social-news" :news="news" :url="'http://instagram.com/smartapant'"></vuestic-social-news> -->
                <div class="text-center">
                    <h2><strong>Aulas Agendadas</strong></h2>
                </div>
                <div class="d-flex justify-content-center flex-column align-items-center">
                    <div class="card col-12">
                        <div class="card-body">
                            <h4 class="card-text"><strong class="mr-3">{{ aulasPraticas }}</strong>Aulas práticas agendadas para hoje.</h4>
                        </div>
                    </div>
                    <div class="card col-12">
                        <div class="card-body">
                            <h4 class="card-text"><strong class="mr-3">{{ aulasTeoricas }}</strong>Aulas teóricas agendadas para hoje.</h4>
                        </div>
                    </div>
                    <div class="card col-12">
                        <div class="card-body">
                            <h4 class="card-text"><strong class="mr-3">{{ turmasTeoricas }}</strong>Turmas agendadas para hoje.</h4>
                        </div>
                    </div>
                </div>
            </vuestic-widget>
        </div>
    </div>
</template>

<script>
import urlApi from '../../router/urlApi'
import urlApiV2 from '@/router/urlApiV2'

export default {
  name: 'dashboard-bottom-widgets',

  data () {
    return {
      posts: [
        {
          name: 'Mariana Maia',
          text: 'iniciou sua aula prática',
          photoURL: 'https://i.imgur.com/VuTDC8u.png'
        },
        {
          name: 'Lucas Falcão',
          text: 'finalizou sua aula prática',
          photoURL: 'https://i.imgur.com/W3mGrmW.png'
        },
        {
          name: 'Felipe Bezerra',
          text: 'faltou a aula téorica',
          photoURL: 'https://i.imgur.com/D7DOGBH.jpg'
        }
      ],
      news: [
        {
          photoURL: 'https://i.imgur.com/PiTDDcA.png'
        },
        {
          photoURL: 'https://i.imgur.com/M6GugaM.png'
        },
        {
          photoURL: 'https://i.imgur.com/vEy3fRU.png'
        },
        {
          photoURL: 'https://i.imgur.com/Xrywphx.png'
        },
        {
          photoURL: 'https://i.imgur.com/dqVtQGY.png'
        },
        {
          photoURL: 'https://i.imgur.com/qP7rTCy.png'
        },
        {
          photoURL: 'https://i.imgur.com/6YLsM43.png'
        },
        {
          photoURL: 'https://i.imgur.com/9PAOx55.png'
        },
        {
          photoURL: 'https://i.imgur.com/mVpc04D.png'
        },
        {
          photoURL: 'https://i.imgur.com/WdbTSLn.png'
        },
        {
          photoURL: 'https://i.imgur.com/ZXRIHfk.png'
        }
      ],
      aulasPraticas: 0,
      aulasTeoricas: 0,
      turmasTeoricas: 0,
      teoricasFinalizadas: 0,
      teoricasCanceladas: 0,
      teoricasConfirmadas: 0,
      teoricasPendentes: 0,
      teoricasRealizadas: 0,
    }
  },
  methods: {
    loadAulas () {
      this.$http.get(`${urlApiV2}/aulas/teoricas/relatorio/status`)
        .then(res => {
          this.teoricasFinalizadas = res.data.dados.finalizadas
          this.teoricasCanceladas = res.data.dados.canceladas
          this.teoricasConfirmadas = res.data.dados.confirmadas
          this.teoricasPendentes = res.data.dados.pendentes
          this.teoricasRealizadas = res.data.dados.realizadas
        })
        .catch(res => {
          this.launchToast('fa-exclamation', error.data.dados)
        })
    },

    launchToast (icon, msg) {
      Vue.toasted.show(msg, {
        icon: icon,
        position: 'top-right',
        duration: 5000,
        fullWidth: false
      })
    }
  },
  mounted () {
    this.loadAulas()

    this.$http.get(urlApi + '/aulas/praticas/hoje').then(function (response) {
      this.aulasPraticas = response.data.dados
    })

    this.$http.get(urlApi + '/aulas/teoricashoje').then(function (response) {
      this.aulasTeoricas = response.data.dados[0]
      this.turmasTeoricas = response.data.dados[1]
    })
  }
}
</script>

<style lang="scss" scoped>
.bottom-widgets {
    >div[class^='col'] {
        &>div {
            width: 100%;
        }
    }
}
</style>
